module.exports = __webpack_public_path__ + "img/slider2.d28f26f5.jpg";